<template>
    <v-row>
        <v-col cols="12" class="text-h6">
            <h3 class="pt-5 kbDarkBlueText--text">{{ title }}</h3>
        </v-col>
        <v-col cols="12">
            <div v-if="Array.isArray(value)">
                <draggable v-model="value" class="layout v-row wrap">
                    <div class="flex xs12 sm6 md3 text-center"
                         v-for="(element, index) in value"
                         :key="element.url">
                        <v-img class="ma-1" style="border-radius: 5px;" :src="element.url" width="200px" height="200">
                            <v-row class="flex-column lightbox white--text pa-2 fill-height">
                                <v-spacer/>
                                <v-col class="shrink" >
                                    <v-btn icon v-if="!readonly" @click="deletePicture(index)">
                                        <v-icon color="white">clear</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-img>
                    </div>
                </draggable>
            </div>

            <div v-else-if="value">
                <v-img class="ma-1" style="border-radius: 5px;" :src="value" width="200px" height="200">
                    <v-row class="flex-column lightbox white--text pa-2 fill-height">
                        <v-spacer/>
                        <v-col class="shrink text-center" >
                            <v-btn icon v-if="!readonly" @click="deleteCoverImage()">
                                <v-icon color="white">clear</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-img>
            </div>
        </v-col>

        <v-col v-if="!readonly" cols="12">
            <v-btn :loading="uploadingPicture"
                   rounded
                   :color="buttonColor || 'kbGray'"
                   dark
                   @click="onPickFile()">{{ $t('general.uploadPhoto') }}</v-btn>
            <input type="file" style="display: none" ref="fileInput" accept="image/*" @change="onFilePicked">
        </v-col>
    </v-row>
</template>

<script>
import { mapState } from 'vuex'
import draggable from 'vuedraggable'
import imagesService from '@/services/imagesService'
export default {
  computed: {
    ...mapState({
      methodNewEditPlace: state => state.events.methodNewEditPlace
    }),
    readonly () {
      return this.methodNewEditPlace === 'view'
    }
  },

  components: { draggable },
  data () {
    return {
      file: {},
      images: [],
      uploadingPicture: false
    }
  },
  methods: {
    onPickFile () {
      this.$refs.fileInput.click()
    },
    onFilePicked (event) {
      const files = event.target.files
      console.log('These are the files', files)
      const filename = files[0].name
      if (filename.lastIndexOf('.') <= 0) {
        return window.alert(this.$t('general.pleaseAddAValidFile'))
      }
      this.file = files[0]
      this.uploadPicture()
    },
    deletePicture (index) {
      this.value.splice(index, 1)
    },
    deleteCoverImage () {
      this.$emit('input', '')
    },
    sortImages () {
      this.value.forEach((image, index) => {
        if (index === 0) {
          this.$set(image, 'main', true)
        } else {
          this.$set(image, 'main', false)
        }
        this.$set(image, 'position', index)
      })
    },
    uploadPicture () {
      this.uploadingPicture = true
      const data = {
        picture: this.file
      }

      imagesService.uploadImageEvent(this.$store.state.auth.token, data).then(response => {
        if (Array.isArray(this.value)) {
          this.value.push({
            url: response.image.url
          })
        } else {
          this.$emit('input', response.image.url)
        }
        this.file = null
        this.$refs.fileInput.value = null
        this.uploadingPicture = false
      }).catch(error => {
        this.file = null
        this.$refs.fileInput.value = null
        this.uploadingPicture = false
        console.error(error)
        // notifications.error(error.message) // -> interceptor.js makes the action of notifying
      })
    }
  },
  watch: {
    images () {
      this.sortImages()
    }
  },
  props: ['title', 'value', 'buttonColor']
}
</script>
